<template>
    <div class="row">
        <div class="col-12">
            <div class="card title">
                <div class="card-body title-filter">
                    <div class="row">
                        <div class="col-lg-12 title-filte-left">
                            <h1 class="title-filter-title">
                                <i class="b-table-icon fa fa-cogs"></i>
                                <p class="pl-1">
                                    Cài đặt trang dữ liệu và giám sát - Bản đồ
                                    <br/>
                                    <small>Đường dẫn: <a :href="getLink('/ban-do-va-lop-du-lieu.html')" target="_blank" >{{getLink('/ban-do-va-lop-du-lieu.html')}}</a></small>
                                </p>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <box-info />
        </div>
    </div>
</template>

<script>
    import Box from './Box';

    export default {
        components: {"box-info": Box},
        methods: {
            getLink(path) {
                return `${this.$store.state.etc['site-frontend-url']}${path}`;
            }
        },
    }
</script>